import React from 'react';

import SelectedItem from './SelectedItem';
import styles from './SelectedItemsList.module.css';
import { SelectedItem as SelectedItemType } from './types';

interface SelectedItemsListProps {
  selectedItems: SelectedItemType[];
  onRemoveItem: (value: string) => void;
}

const SelectedItemsList: React.FC<SelectedItemsListProps> = ({ selectedItems, onRemoveItem }) => {
  if (selectedItems.length === 0) {
    return null;
  }

  const itemCount = selectedItems.length;
  const ariaLabel = `${itemCount} item${itemCount === 1 ? '' : 's'} selected`;

  return (
    <div className={styles.selectedContainer}>
      <div className={styles.selectedHeader}>Selected Items:</div>
      <div className={styles.selectedList} role="list" aria-label={ariaLabel}>
        {selectedItems.map((item) => (
          <SelectedItem key={item.value} item={item} onRemove={onRemoveItem} />
        ))}
      </div>
    </div>
  );
};

export default SelectedItemsList;
